import { useStore as getStore } from "../../utils/useStore.js";
import cookieFactory from "./cookieFactory.js";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const initialState = () => ({
  // allow the site to use cookies
  CookieUsage: cookies.get("CookieUsage") || null,
});

const [CookieProvider, useCookie, withCookie] = getStore(
  cookieFactory,
  initialState,
  "Cookie"
);

export const cookieInitState = initialState();

export { useCookie, CookieProvider, withCookie };

export default CookieProvider;
